<template>
  <div
    class="toast-layout"
    :style="[modelValue ? 'z-index: 999;' : 'z-index: 0; visibility: hidden;']"
  >
    <transition name="toast-fade" :style="{ background: backgroundColor() }">
      <div v-if="modelValue" class="toast">
        <img :src="TOAST_ICON[state || 0]" />
        <p>{{ message }}</p>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { TOAST_ICON } from "../consts/common";
export type ToastProps = {
  modelValue: boolean;
  message: string;
  state?: number; // 0:success, 1: fail , 2: alert していない場合は0
  timeout?: number;
};
// APIを公開
defineExpose({
  close,
});

interface Emits {
  (e: "update:modelValue", value: boolean): void;
}

const props = defineProps<ToastProps>();
const emit = defineEmits<Emits>();

function close() {
  emit("update:modelValue", false);
}

function backgroundColor() {
  if (props.state == 0) {
    return "#EEF9F3";
  } else if (props.state == 1) {
    return "#FFF2F3";
  } else if (props.state == 2) {
    return "rgba(254, 250, 231, 1)";
  }
  return "#EEF9F3";
}

watch<boolean>(
  () => props.modelValue,
  (newValue) => {
    if (props.timeout && newValue) {
      setTimeout(() => {
        emit("update:modelValue", false);
      }, props.timeout);
    }
  }
);
watch<number | undefined>(
  () => props.timeout,
  (newValue) => {
    if (newValue && props.modelValue) {
      setTimeout(() => {
        emit("update:modelValue", false);
      }, props.timeout);
    }
  }
);
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
.toast-layout {
  display: flex;
  position: fixed;
  top: 10px;
  width: 100%;
  max-width: 480px;

  flex-direction: column;
  height: 38px;
  text-align: center;
}
.toast {
  background-color: $OMOT_COLOR;
  color: #333333;
  padding: 10px 20px;
  margin: auto;
  display: inline-flex;
  justify-content: center;
  z-index: 900;
  opacity: 0.9;
  text-align: center;
  width: 300px;
  p {
    // margin: 0;
    padding: auto;
    margin: 5px 10px;
  }
}
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: 1s fadeIn forwards;
}
.toast-fade-enter,
.fade-leave-to {
  opacity: 0;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
